import {useNavigate, useParams, useLocation} from 'react-router-dom'
import {HeaderTitle} from '../../../../../common/HeaderTitle.jsx'
import ButtonWithIcon from '../../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../../common/Icons.jsx'
import Wizard from '../../../../../common/wizard/Wizard.jsx'
import {
    DanePodstawowe,
    Finansowanie,
    Kontakt,
    Podsumowanie,
    Ryzyka,
    Start,
} from '../../../lib/components/sprawozdanieForm/s2/pages/index.js'
import {useSelector} from 'react-redux'
import {useZlozSprawozdanie} from "../../../../../../api/domain/sprawozdania/mutations/useZlozSprawozdanie.jsx";
import {CLEAR_S} from "../../../lib/components/sprawozdanieForm/s2/clearing/clear_s.js";
import { ModalInfoProjekt } from '../../../lib/components/modals.jsx';
import {useState} from "react";

const ViewSprawozdanieForm = () => {

    const WZOR_NAME = 's2'
    const {rejestrId, tryb, sprawozdanieId} = useParams()
    const rola = useSelector((state) => state.user.role)
    const wizardId = useSelector((state) => state.wizard?.id)
    const rolaParam = rola === 'oper' ? 'oper/' : '/'
    const wersja = sprawozdanieId ? `/${sprawozdanieId}` : ''
    const navigate = useNavigate();
    const location = useLocation();
    const backTo = location.state?.from ?? `/${rola}/rejestr/lista`
    const clear_s = new CLEAR_S()

    const {mutate: zlozSprawozdanie} = useZlozSprawozdanie()
    const [showInfoModal, setShowInfoModal] = useState(false);

    const acceptButtons = () => {
        return (
            <ButtonWithIcon
                icon={<Icons.send/>}
                onClick={() => zlozSprawozdanie({id: wizardId})}
                variant={'success'}
                text={'Złóż sprawozdanie'}
                className={'ms-0 p-2'}
            />
        )
    }

    return (
        <>
            <ModalInfoProjekt
                show={showInfoModal}
                handleClose={() => setShowInfoModal(false)}
                rejestrId={rejestrId}
            />
            <HeaderTitle
                home
                nav
                size={'fs-2'}
                breadcrumbLinks={[
                    {
                        label: 'Wszystkie projekty',
                        to: `/${rola}/rejestr/lista`,
                    },
                    {label: 'Wypełnij sprawozdanie'},
                ]}
                destination={backTo}
                data={[['ID', rejestrId]]}
                title={'Wypełnij sprawozdanie'}
            />
            <div className="d-flex justify-content-end mb-3 pe-3">
                <ButtonWithIcon
                    icon={<Icons.info size={20}/>}
                    onClick={() => setShowInfoModal(true)}
                    variant={'info'}
                    text={'Informacje o projekcie'}
                    className="text-white"
                />
            </div>
            <Wizard
                debug
                mode={tryb}
                name={WZOR_NAME}
                dataUrl={`${rolaParam}sprawozdanie/${rejestrId}${wersja}`}
                validationUrl={`${rolaParam}sprawozdanie/${rejestrId}${wersja}/podsumowanie`}
                saveUrl={`${rolaParam}sprawozdanie`}
                mappingUrl={`${rolaParam}sprawozdanie/wzor/${WZOR_NAME}`}
                acceptButtons={acceptButtons}
                saveOnPageChange={true}
                stateForPage={false}
                saveAndQuitCallback={() => navigate(-1)}
                cancelCallback={() => navigate(-1)}
                filterByCategory={false}
                pages={[
                    {name: 'start', form: <Start/>},
                    {name: 'dane_podstawowe', calc: (form) => clear_s.dane(form), form: <DanePodstawowe/>},
                    {name: 'finansowanie', form: <Finansowanie/>},
                    {name: 'ryzyka', calc: (form) => clear_s.ryzyka(form), form: <Ryzyka/>},
                    {name: 'kontakt', calc: (form) => clear_s.kontakt(form), form: <Kontakt/>},
                    {
                        name: 'podsumowanie',
                        form: <Podsumowanie/>,
                        summary: true,
                    },
                ]}
            />
        </>
    )
}

export default ViewSprawozdanieForm
